import { Anchor, AnchorProps } from "@mantine/core"
import { NavigateOptions, useNavigate } from "@tanstack/react-router"
import { ReactNode } from "react"

interface Props extends AnchorProps {
  navigateOptions: NavigateOptions
  linkText?: ReactNode
}

export function Link({ navigateOptions, linkText, ...props }: Props) {
  const navigate = useNavigate()

  return (
    <Anchor
      onClick={(evt) => {
        evt.preventDefault()
        navigate(navigateOptions)
      }}
      {...props}
    >
      {linkText}
    </Anchor>
  )
}
